<template>
  <ul>
    <li>
      <a :href="data.linkUrl + 'P=1'">1</a>
    </li>
    <li>
      <span>...</span>
    </li>
    <li v-for="page in prevPages" :key="page">
      <a :href="data.linkUrl + 'P=' + page">{{ page }}</a>
    </li>
    <li class="active">
      <span>{{ data.page }}</span>
    </li>
    <li v-for="page in nextPages" :key="page">
      <a :href="data.linkUrl + 'P=' + page">{{ page }}</a>
    </li>
  </ul>
</template>

<script setup>
import { ref } from 'vue';
// 後最大連續個數頁的分頁選擇器組件
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const prevPages = ref([]);
const nextPages = ref([]);

function init() {
  for (var i = props.data.pageTotal - props.data.maxCont + 1; i <= props.data.pageTotal; i++) {
    if (i < props.data.page) {
      prevPages.value.push(i);
    } else if (i > props.data.page) {
      nextPages.value.push(i);
    }
  }
}
init();
</script>

<style lang="scss" scoped></style>
